import React, { useState } from "react";
import { ChartColumn, UserPlus } from "lucide-react";
import Pipeline from "./Pipeline";
import RoleRequestTable from "./RoleRequestTable";
import RequestForm from "./RequestForm";
import CustomTabs from "components/tabs/customTab";

const RecruitmentOverviewTabs = () => {
    const [activeTab, setActiveTab] = useState("JobRoleRequest");
    
    const TabLabel = ({ icon: Icon, text }) => (
    <div className="flex items-center justify-center gap-2">
        <Icon className="text-slate-900 w-4 h-4 dark:text-white" />
        <span className="text-sm font-medium">{text}</span>
    </div>
    );

    const tabOptions = [
        { label: <TabLabel icon={ChartColumn} text="Job Role Request" />, value: "JobRoleRequest" },
        { label: <TabLabel icon={UserPlus} text="Request" />, value: "Request" },
    ];

    return (
        <div className="space-y-6">
            <CustomTabs
                tabs={tabOptions}
                activeTab={activeTab}
                onChange={setActiveTab}
            />

            <>
                {activeTab === "JobRoleRequest" && (
                    <RoleRequestTable />
                )}

                {activeTab === "Request" && (
                    <RequestForm recordId={0}/>
                )}
            </>
        </div>
    );
};

export default RecruitmentOverviewTabs;
